const DETAIL_HEADERS = new Set(['Ingredients:', 'Directions:', 'Caution:']);

function splitDescriptionSections(description) {
  return (description || '')
    .split(/\n\s*\n/)
    .filter((section) => section.trim())
    .map((section) => {
      const lines = section.trim().split('\n');
      const firstLine = lines[0].trim();
      const isLabeledHeader = /:$/.test(firstLine);
      return {
        header: isLabeledHeader ? firstLine : null,
        body: isLabeledHeader
          ? lines.slice(1).join('\n').trim()
          : section.trim(),
      };
    });
}

function formatOneLiner(section) {
  return section.header
    ? `${section.header} ${section.body}`.trim()
    : section.body;
}

export function parseProductCopy(description) {
  const sections = splitDescriptionSections(description);
  const oneLiners = [];
  const productDetails = [];

  sections.forEach((section) => {
    if (section.header && DETAIL_HEADERS.has(section.header)) {
      productDetails.push(section);
    } else {
      oneLiners.push(section);
    }
  });

  return { oneLiners, productDetails };
}

/**
 * Shop-card blurb: last intro one-liner before Ingredients/Directions/Caution.
 * Ignores trailing lines like size (e.g. "56 mL/ 2 fL. Oz.").
 */
export function getProductTagline(description) {
  const introOneLiners = [];

  for (const section of splitDescriptionSections(description)) {
    if (section.header && DETAIL_HEADERS.has(section.header)) break;
    introOneLiners.push(section);
  }

  if (!introOneLiners.length) return '';
  return formatOneLiner(introOneLiners[introOneLiners.length - 1]);
}
